export default __webpack_public_path__ + "static/media/thumbs_up_down-default.12808123.svg";